import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DataGridService } from '../data-grid.service';

@Component({
  selector: 'ss-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginatorComponent {

  readonly pageIdxSubject = this._dataGridService.pageIdxSubject;
  readonly pageSize = this._dataGridService.pageSize;
  readonly totalLengthSubject = this._dataGridService.totalLengthSubject;
  readonly showCollapsedModeSubject = this._dataGridService.showCollapsedModeSubject
  constructor(
    private readonly _dataGridService: DataGridService
  ) {

  }
}
